import(/* webpackMode: "eager" */ "/vercel/path0/app/(global)/cookies/page.tsx");
